import { TransitionTarget } from '../models/internal/transition-target';

const translationObject: { [Key in TransitionTarget]: string } = {
    [TransitionTarget.Invoice]: 'app.document.invoice',
    [TransitionTarget.PurchaseOrder]: 'app.document.purchaseOrder',
    [TransitionTarget.Inquiry]: 'app.document.inquiry',
    [TransitionTarget.Credit]: 'app.document.credit',
};

export const getTranslationIdByTarget = (transitionTarget: TransitionTarget): string => {
    return translationObject[transitionTarget];
};
